import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { useTranslation } from 'react-i18next';
import { checkVietNam } from '@src/utils/checkCountry';
import { checkCustomPackage, formatPrice } from '@src/services/package';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';

const getPricePerCCR = (pkg, language) => {
  const isVietNam = checkVietNam();
  const vndPricePerUnit =
    pkg?.customResource?.concurrentRequestApi?.prices?.[0]?.vndPricePerUnit;
  const usdPricePerUnit =
    pkg?.customResource?.concurrentRequestApi?.prices?.[0]?.usdPricePerUnit;

  return formatPrice({
    vndPrice: vndPricePerUnit,
    usdPrice: usdPricePerUnit,
    isVietNam,
    language,
  });
};

const PurchaseAdditionalCCRFeature = ({ pkg }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isCustomPackage = checkCustomPackage({
    type: pkg.type,
    level: pkg.level,
  });

  if (isCustomPackage) {
    const pricePerCCR = getPricePerCCR(pkg, language);
    const description = pkg?.customResource?.concurrentRequestApi?.description;

    return (
      <Text
        key={pkg.code}
        html={
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                t(description[language], {
                  pricePerUnit: pricePerCCR,
                }),
                {
                  allowedTags: ['span'],
                  allowedAttributes: {
                    span: ['style'],
                  },
                },
              ),
            }}
          />
        }
      />
    );
  }

  return <CheckOrCross key={pkg.code} isCheck={false} />;
};

const purchaseAdditionalCCRFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <PurchaseAdditionalCCRFeature key={pkg.code} pkg={pkg} />
  ));

export default purchaseAdditionalCCRFeatures;
